import { getAppConfig } from '../../constants/appConfig';
import { DOMAIN_TYPES } from "../../constants/CustomHRD/constants";

const buildAuthorizeUrl = ({ gotoUrl, email, domainType }) => {
  const authorizeUrl = new URL(gotoUrl);

  switch (domainType) {
    case DOMAIN_TYPES.NON_FEDERATED:
      authorizeUrl.searchParams.set("login_hint", email);
      authorizeUrl.searchParams.set("domain_hint",getAppConfig().REACT_APP_NON_FED_DOMAIN_HINT);
      break;

    case DOMAIN_TYPES.RESTRICTED_NON_FEDERATED:
      authorizeUrl.searchParams.delete("login_hint");
      authorizeUrl.searchParams.set("domain_hint", getAppConfig().REACT_APP_NON_FED_DOMAIN_HINT);
      break;

    case DOMAIN_TYPES.FEDERATED:
    default:
      authorizeUrl.searchParams.set("login_hint", email);
      authorizeUrl.searchParams.delete("domain_hint");
      break;
  }

  return authorizeUrl.toString();
};

export default buildAuthorizeUrl;